import React from "react";
import { useTranslation } from "react-i18next";

import { WPRangedInput } from "../../../packages/WPInput/WPRangedInput";

import { FIELD_ENTRIES, getFieldSuffix } from "../utilityCosts.config";

import "./index.scss";

const UtilityCostFields = ({
  values,
  currency,
  volume,
  fieldRanges,
  onChange,
  onValidationError,
  containerClassName = "",
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`utility-costs-fields ${containerClassName}`}>
      {FIELD_ENTRIES.map(([key, field]) => (
        <div key={key}>
          <WPRangedInput
            value={values[key]}
            name={key}
            label={t(`utilityCosts.${key}`)}
            suffix={getFieldSuffix(field, currency, volume)}
            onChange={(value) => onChange?.(key, value)}
            onValidationError={(errorMessage) =>
              onValidationError?.(key, errorMessage)
            }
            ranges={fieldRanges?.[key] || field.ranges}
            fractions={2}
            required
            requiredMsg={t("ValueStrings.requiredField")}
            disabled={disabled}
            showRangeAlways={!disabled}
          />
        </div>
      ))}
    </div>
  );
};

export default UtilityCostFields;
